// extracted by mini-css-extract-plugin
module.exports = {"overlayWrapper":"SessionExpiry_overlayWrapper___RSZf"};